import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { affiliatesListQueries } from '@/services/affiliate/affiliate.queries';
import { AffiliateDetail } from '@/services/affiliate/affiliate.types';

const useAffiliateDetail = (affiliateId: string) => {
  const { data, isSuccess, isPending, dataUpdatedAt } = useQuery({
    ...affiliatesListQueries.detail(affiliateId),
    enabled: !!affiliateId,
  });

  return {
    affiliateDetail: (data?.data as AffiliateDetail) || ({} as AffiliateDetail),
    isSuccess,
    isPending,
    dataUpdatedAt,
  };
};

export default useAffiliateDetail;
